import { h } from 'preact';
import AlertIcon from '../../globals/assets/alert.svg';
import Text from '../Text';
import styles from './errorBoundary.scss';
import messages from './messages';

export const ErrorBoundaryComponent = () => {
  return (
    <div className={styles.container}>
      <AlertIcon className={styles.alertIcon} />
      <p className={styles.header}>
        <Text
          id="errorBoundaryHeader"
          defaultMessage={messages.errorBoundaryHeader}
        />
      </p>
      <p className={styles.subHeader}>
        <Text
          id="errorBoundarySubHeader"
          defaultMessage={messages.errorBoundarySubHeader}
        />
      </p>
    </div>
  );
};
